import { UseCase } from '../UseCase';
import { HistoricRepository } from '../../repositories/HistoricRepository';
import { Sell } from '../../models/Sell';
import { QueryByType } from '../../constants/QueryByType';

export class GetHistoricOpsByDateUseCase implements UseCase<GetHistoricOpsByDateRequestDto, Sell[]>{

    constructor(
        private historicRepo: HistoricRepository
    ) { }

    execute(t: GetHistoricOpsByDateRequestDto): Promise<Sell[]> {
        return this.historicRepo.getHistoricTransactionsByDate(t.queryBy, t.date, t.page, t.all);
    }
}

export class GetHistoricOpsByDateRequestDto {
    constructor(
        public queryBy: QueryByType,
        public date: string,
        public page: number,
        public all: boolean = false
    ) { }
}
